// Packages
import tw, { styled } from 'twin.macro'

import ArrowDown from '../../_images/arrow-down.svg'

export const Container = styled.div(() => [
  `@media screen and (max-width: 1024px) { justify-content:space-between};`,
  tw`md:max-w-screen-md lg:max-w-screen-lg mx-auto text-white text-copy md:flex lg:gap-4 pt-4`,
])

export const Filter = styled.div(() => [
  `@media screen and (min-width: 768px) {width: calc((100% - 32px)/3);}`,
  tw``,
])

export const Label = styled.label(() => [
  ``,
  tw`pb-1 block md:pr-2 md:pb-0 mb-0.5 font-medium text-gray-700`,
])

export const LabelRow = styled.div(() => [
  ``,
  tw`flex items-center justify-between gap-2`,
])

export const InlineCheckbox = styled.label(() => [
  `input { accent-color: #006FCF; width: 16px; height: 16px; }`,
  tw`flex items-center gap-2 pb-1 md:pb-0 mb-0.5 text-sm font-medium text-gray-700 whitespace-nowrap cursor-pointer`,
])

// Wraps InlineCheckbox when it stands alone as its own row in the mobile
// accordion (just below the Cuisine section), matching the divider/spacing
// of the AccordionItem rows around it.
export const AccordionCheckboxRow = styled.div(() => [
  ``,
  tw`border-b border-gray-200 py-4`,
])

export const Select = styled.select(() => [
  `
  background-image: url(${ArrowDown});
  background-size: 20px 20px;
  background-position: calc(100% - 10px) 50%;
  background-repeat: no-repeat;
  background-color: white;
  `,
  `
  :hover {
    background-color: rgba(236, 237, 238, 0.7);
  }
  `,
  `
  :focus {
    outline: 1px dashed #fff;
    outline-offset: 3px;
  }
  `,
  tw`cursor-pointer overflow-ellipsis appearance-none text-black h-12 leading-10 w-full mb-6 md:h-12 md:mb-0 px-4 bg-white rounded border border-[#ECEDEE]`,
])

export const Checkbox = styled.div(() => [
  ``,
  tw`text-copy text-white text-right items-center flex `,
])

export const CheckboxContents = styled.div(() => [
  ``,
  tw`text-copy text-white text-right mt-5 `,
])

// Mobile accordion filters
export const AccordionItem = styled.div(() => [tw`border-b border-gray-200`])

export const AccordionHeader = styled.button(() => [
  `
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 2px;
  }
  `,
  tw`w-full flex items-center justify-between gap-4 py-4 text-left text-[#333333] text-base cursor-pointer bg-transparent`,
])

export const AccordionChevron = styled.span(({ open }) => [
  `transition: transform 0.2s ease-in-out;`,
  open ? `transform: rotate(180deg);` : `transform: rotate(0deg);`,
  tw`inline-flex shrink-0`,
])

export const AccordionPanel = styled.div(() => [tw`pb-2`])

export const RadioGroupHeading = styled.div(() => [
  tw`text-[#333333] font-normal mt-2 mb-1`,
])

export const RadioRow = styled.label(() => [
  `input { accent-color: #006FCF; width: 18px; height: 18px; flex-shrink: 0; }`,
  tw`flex items-center gap-3 py-2 text-[#333333] text-base cursor-pointer`,
])
